var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:chevron-up-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.38375 7.86625L10.5 11.9813L14.6163 7.86562L15.5 8.75L10.5 13.75L5.5 8.75L6.38375 7.86625Z",
    fill: "#00796B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.25 10C19.25 5.175 15.325 1.25 10.5 1.25C5.675 1.25 1.75 5.175 1.75 10C1.75 14.825 5.675 18.75 10.5 18.75C15.325 18.75 19.25 14.825 19.25 10ZM3 10C3 5.86438 6.36438 2.5 10.5 2.5C14.6356 2.5 18 5.86438 18 10C18 14.1356 14.6356 17.5 10.5 17.5C6.36438 17.5 3 14.1356 3 10Z",
    fill: "#00796B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle-arrow-down.0dff95d0cfb08f34b8663415f22a411d.svg";
export { ForwardRef as ReactComponent };